/* EU stores — every description order-CTA (.vxg-cta, .vxcob-cta, .fnx-cta,
   .fnx-c100-cta, .fnx-skg-cta, .fnx-scroll-to-shopify, …): keep the customer in the funnel by scrolling to the buy box (price + bundle + ATC + COD) instead of reloading / dead-anchor / Shopify checkout. The <a> grabbing focus pulls the page back, so block focus + re-assert the scroll. */
(function vxgScrollToBuyBox(){
  if (typeof document === 'undefined') return;
  /* One delegated matcher for every per-product CTA naming variant. The
     descriptions ship 14 different class names for the same button and their
     hrefs are unusable: some have none, some point at #order / # (targets that
     never render) and some at the product's OWN absolute url, which reloads the
     page and drops the cart. Matching the vx…-cta / fnx…-cta convention covers
     all current and future products. */
  var CTA_RX = /(?:^|\s)(?:vx|fnx)[\w-]*-cta(?=\s|$)/;
  function descCta(target){
    var a = target && target.closest ? target.closest('a') : null;
    if (!a) return null;
    var cls = (a.className || '') + '';
    return (CTA_RX.test(cls) || /fnx-scroll-to-shopify/.test(cls)) ? a : null;
  }
  function buyBoxTop(){
    return document.querySelector('.pt-pdp__price, .fn-pdp-price, .fn-pdp__title-price, .fn-pdp__price-row')
        || document.querySelector('[name="add"]')
        || document.querySelector('.fn-add-to-cart-btn, .pt-pdp__add, [data-fn-pdp-add]')
        || document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('h1');
  }
  function jumpTo(t){
    var se = document.scrollingElement || document.documentElement;
    var r = t.getBoundingClientRect();
    se.scrollTop = Math.max(0, se.scrollTop + r.top - 90); /* price ~90px from top → whole buy box visible below */
  }
  function highlight(){
    var hl = document.querySelector('[data-fn-pdp-add], .fn-add-to-cart-btn, .pt-pdp__add, [name="add"]');
    if (!hl) return;
    try { hl.style.transition='box-shadow .3s ease'; hl.style.boxShadow='0 0 0 3px rgba(180,83,9,.6)'; setTimeout(function(){ hl.style.boxShadow=''; }, 1600); } catch(e){}
  }
  /* block the <a> from taking focus — its focus-scroll yanks the page back */
  document.addEventListener('mousedown', function(e){
    var a = descCta(e.target);
    if (a) e.preventDefault();
  }, true);
  document.addEventListener('click', function(e){
    var a = descCta(e.target);
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    try { a.blur(); } catch(_){}
    var t = buyBoxTop(); if (!t) return;
    jumpTo(t);
    setTimeout(function(){ jumpTo(t); }, 80);
    setTimeout(function(){ jumpTo(t); highlight(); }, 340);
  }, true);
})();